import $ from 'jquery';
import _ from 'underscore';
import UI from 'root/ui';
import Cache from 'root/cache';
import Util from 'root/module/util';
import Modals from 'root/modals';
import View from 'view/base';

export default View.extend({
    className: 'revision-dropdown',

    events: {
        'click .revision-item'   : 'selectRevision',
        'click .revision-delete' : 'deleteRevision',
        'click .revision-new'    : 'uploadRevision',
        'change .revision-input' : 'uploadImage',
        'click .approve'         : 'approveDesign'
    },

    dom_handlers: {
        selectRevision: function(e) {
            if ($(e.currentTarget).find('.fa-check').length) {
                return;
            }

            var screenshot_id = parseInt($(e.currentTarget).data('id'));

            this.dispatcher.trigger('Screenshot_Thumbnail:Select', screenshot_id);
            this.render();
        },

        deleteRevision: function(e) {
            e.stopPropagation();

            var screenshot_id  = parseInt($(e.currentTarget).parents('li:first').data('id'));
            var screenshot_num = 0;

            Cache.feedback_screenshot.each(function(model, index) {
                if (screenshot_id === model.id) {
                    screenshot_num = index;
                }
            });

            var callback;
            var current_id = Cache.feedback_screenshot.at(this.screenshot_num()).id;

            if (screenshot_num < this.screenshot_num()) {
                callback = function() {
                    this.dispatcher.trigger('Screenshot_Thumbnail:Select', current_id);
                    this.render();
                };
            } else if (screenshot_num === this.screenshot_num()) {
                callback = function() {
                    this.dispatcher.trigger('Screenshot_Thumbnail:Select', Cache.feedback_screenshot.last().id);
                    this.render();
                };
            } else {
                callback = function() {
                    this.render();
                };
            }

            Modals.deleteFeedbackRevision(screenshot_id, screenshot_num, callback.bind(this));
        },

        uploadRevision: function(e) {
            $('<input>')
                .attr('type', 'file')
                .attr('accept', 'image/png, image/jpeg, image/gif')
                .addClass('hidden revision-input')
                .appendTo(this.$el).click();
        },

        uploadImage: function(e) {
            var files = e.target.files || e.dataTransfer.files;

            if (files.length > 1) {
                UI.error('Please upload one revision at a time.');
                return;
            }

            if (files.length === 0) {
                return;
            }

            this.$el.find('.revision-input').remove();

            var is_approved = Cache.feedback_screenshot.where({feedback_id: this.model.id, is_approved: true}).length > 0;
            var is_approver = Cache.feedback_approver.where({feedback_id: this.model.id, user_id: Cache.real_user_id}).length > 0;
            var is_pending_approval = Cache.feedback_approver.where({feedback_id: this.model.id}).length > 0 && !is_approved;

            var approver;

            var cta_button_text;
            var close_link;
            var help_text;

            if (is_pending_approval && !is_approver) {
                var approver_id = Cache.feedback_approver.findWhere({feedback_id: this.model.id}).get('user_id');
                approver = Cache.user.get(approver_id);

                help_text = '<i class="far fa-envelope"></i> Notify <b>' + approver.get('name') + '</b> to approve this new version?';
                cta_button_text = 'Yes, notify';
                close_link = 'I\'ll do it later';
            } else {
                cta_button_text = 'View new version';
            }

            Modals.uploadFiles(files, 15, true, 'feedback/uploadRevision', cta_button_text, function(response) {
                if (is_pending_approval && !is_approver) {
                    Cache.app.request({
                        action: 'feedback/notifyApprover',
                        context: this,
                        data: {
                            id: this.model.id
                        },
                        success: function(response) {
                            UI.success('Notification email sent to ' + approver.get('name') + ' (' + approver.get('email') + ')');
                        }
                    });
                }
            }.bind(this), undefined, function(response) {
                Cache.feedback_screenshot.add(response);

                this.dispatcher.trigger('Screenshot_Thumbnail:Select', Cache.feedback_screenshot.at(Cache.feedback_screenshot.length - 1).id);
                this.render();
            }.bind(this), close_link, help_text);
        },

        approveDesign: function() {
            var screenshot_id = Cache.feedback_screenshot.at(this.screenshot_num()).id;
            Modals.approveFeedbackImageRevision(screenshot_id, this.screenshot_num());
        }
    },

    event_handlers: {
        onScreenshotAdd: function(model) {
            // shouldn't need to worry about reselecting a revision because the newly added revision is always greater than the current version
            this.render();
        },

        onScreenshotApprove: function() {
            this.render();
        },

        onApproverChange: function(model) {
            if (model.get('feedback_id') === this.model.id) {
                this.render();
            }
        }
    },

    initialize: function(options) {
        this.screenshot_num = options.screenshot_num;
        this.dispatcher     = options.dispatcher;

        this.listenTo(Cache.feedback_screenshot, 'add',                this.event_handlers.onScreenshotAdd);
        this.listenTo(Cache.feedback_screenshot, 'change:is_approved', this.event_handlers.onScreenshotApprove);

        this.listenTo(Cache.feedback_approver,   'add',    this.event_handlers.onApproverChange);
        this.listenTo(Cache.feedback_approver,   'remove', this.event_handlers.onApproverChange);
    },

    getTotalRevision: function() {
        return Cache.feedback_screenshot.where({feedback_id: this.model.id}).length;
    },

    isApproved: function() {
        return Cache.feedback_screenshot.where({feedback_id: this.model.id, is_approved: true}).length > 0;
    },

    getApprovedBy: function() {
        var approved_screenshot = Cache.feedback_screenshot.findWhere({feedback_id: this.model.id, is_approved: true});

        if (approved_screenshot) {
            var user_id = approved_screenshot.get('approved_by');
            var user    = Cache.user.get(user_id);

            if (user) {
                return user.get('name');
            } else {
                return 'Deleted user';
            }
        }

        return '';
    },

    getApprover: function() {
        var approver = Cache.feedback_approver.findWhere({feedback_id: this.model.id});

        if (approver) {
            var user_id = approver.get('user_id');
            var user    = Cache.user.get(user_id);

            if (user) {
                return user.get('name');
            } else {
                return 'Deleted user';
            }
        }

        return '';
    },

    isPendingApproval: function() {
        return Cache.feedback_approver.where({feedback_id: this.model.id}).length > 0 && !this.isApproved();
    },

    isApprover: function() {
        return Cache.feedback_approver.where({feedback_id: this.model.id, user_id: Cache.real_user_id}).length > 0;
    },

    render: function(options) {
        var has_upload_button = Cache.real_user_id && !Cache.app.isClient() ? true : false;

        var content = '';

        content += '<div class="button-dropdown button-dropdown-up button-dropdown-left">' +
                        '<button type="button" class="small primary primary-invert' + (has_upload_button ? ' split-with' : '') + '">Version ' + (this.screenshot_num() + 1) + ' of ' + this.getTotalRevision() + '<i class="far fa-angle-down"></i></button>' +
                        '<div>' +
                            '<ul class="dropdown">';

        _.each(Cache.feedback_screenshot.clone().models.reverse(), function(model, index) {
            var version = Cache.feedback_screenshot.length - index;

            content +=         '<li class="revision-item dropdown-action" data-id="' + model.id + '">' +
                                    (this.screenshot_num() === version - 1 ?
                                    '<i class="far fa-check"></i>' :
                                    '<span class="icon-placeholder"></span>') +
                                    'Version ' + (version) +
                                    (model.get('is_approved') ? '<span class="badge-small badge-success margin-left-8">Approved</span>' : '') +
                                    '<br>' +
                                    '<span class="icon-placeholder"></span><span class="info">' + (model.get('upload_time') ? Util.moment(model.get('upload_time')) : Util.moment(this.model.get('time'))) + '</span>' +
                                    (Cache.feedback_screenshot.length > 1 && Cache.real_user_id && !Cache.app.isClient() ?
                                    '<div class="action-buttons">' +
                                        '<button class="revision-delete text-danger tooltip" data-title="Delete"><i class="far fa-trash-alt"></i></button>' +
                                    '<div>' : '') +
                                '</li>';
        }, this);

        content +=         '</ul>' +
                        '</div>' +
                    '</div>';

        if (has_upload_button) {
            content += '<button class="revision-new small primary primary-invert tooltip" data-title="Add a new version"><i class="far fa-plus"></i></button>';
        }

        if (this.isApproved()) {
            content += '<span class="approval-status badge-small badge-success tooltip" data-title="Approved by ' + this.getApprovedBy() + '"><i class="fas fa-check-circle"></i> Approved</span>';
        } else if (this.isApprover()) {
            content += '<button class="small success approve font-weight-semibold">Approve</button>';
        } else if (this.isPendingApproval()) {
            content += '<span class="approval-status badge-small badge-warning tooltip" data-title="Pending approval from ' + this.getApprover() + '"><i class="fas fa-info-circle"></i> Pending</span>';
        }

        this.$el.html(content);

        return this;
    }
});